const translationModifier = str => str

export default translationModifier